import React, { Suspense, useImperativeHandle, useEffect, useRef, useState } from 'react'
import { FormDependencyLoaderProvider } from '../../context/FormDependencyLoaderContext'
import Protected from '../../Protected'
import { IEnquiryDetail, IRequestInformation } from '../../../models/Enquiry'
import EnquiryService from '../../../services/EnquiryService'
import { useHistory } from 'react-router-dom'
import useErrorHandler from '../../../hooks/useErrorHandler'
import Conditional from '../../common/Conditional'
import EnquiryRequestForInformationRow from './EnquiryRequestForInformationRow'
import Button from 'semantic-ui-react/dist/commonjs/elements/Button'
import EnquiryRequestForInformationForm from './EnquiryRequestForInformationForm'
export interface IEnquiryDefaultProps {
  clearErrors: () => void
  handleErrors?: (any) => void
  data: IRequestInformation[]
}

const EnquiryRequestInformationLanding = React.forwardRef((props: IEnquiryDefaultProps, ref) => {
  const mountedRef = useRef(false)
  const [, setIsLoading] = useState(true)
  const [data, setData] = useState<IEnquiryDetail>()
  const queryParams = new URLSearchParams(location.search)
  const enquiryId = queryParams.get('id')
  const [, , handleErrors, ,] = useErrorHandler()
  const history = useHistory()
  const [form, setForm] = useState({
    visible: false,
    data: null,
  })
  useEffect(() => {
    mountedRef.current = true
    EnquiryService.getEnquiryDetails(enquiryId)
      .then((response) => {
        if (mountedRef.current) {
          const result = response.result
          setData(result)
        }
      })
      .catch((error) => {
        handleErrors(error)
      })
      .finally(() => {
        if (mountedRef.current) {
          setIsLoading(false)
        }
      })

    return () => {
      mountedRef.current = false
    }
  }, [])

  const backtoEnquiries = () => {
    history.push('/my-account/enquiries')
  }
  useImperativeHandle(ref, () => ({
    clear() {
      setForm((prevState) => ({
        ...prevState,
        data: null,
        visible: false,
      }))
    },
  }))

  const displayForm = (requestForInformation: IRequestInformation) => {
    setForm((prevState) => ({
      ...prevState,
      data: requestForInformation,
      visible: true,
    }))
  }

  const close = () => {
    setForm((prevState) => ({
      ...prevState,
      visible: false,
    }))
  }

  return (
    <>
      <Suspense fallback={null}>
        <Protected>
          <div className="content-wrapper">
            <article className="main">
              <FormDependencyLoaderProvider>
                <h2>Request for information</h2>
                <p></p>
                <h3>Enquiry number : {data?.number}</h3>
                <p></p>
                <Conditional if={data?.requestInformation}>
                  <div className="table-wrapper">
                    <table id="table-requestinfo">
                      <thead>
                        <tr>
                          <th>Subject</th>
                          <th>Responded</th>
                          <th>Date requested</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.requestInformation?.map((item, index) => {
                          return (
                            <EnquiryRequestForInformationRow
                              key={index}
                              item={item}
                              displayForm={displayForm}
                            />
                          )
                        })}
                      </tbody>
                    </table>
                  </div>
                  <Button className="is-secondary" onClick={() => backtoEnquiries()}>
                    Return to enquiry list
                  </Button>
                </Conditional>

                <Conditional if={form.visible}>
                  <EnquiryRequestForInformationForm
                    data={form.data}
                    close={close}
                    handleErrors={props.handleErrors}
                    enquiryId={enquiryId}
                    enquiryNumber={data?.number}
                    enquiryStatus = {data?.status}

                  />
                </Conditional>
              </FormDependencyLoaderProvider>
            </article>
          </div>
        </Protected>
      </Suspense>
    </>
  )
}
)
EnquiryRequestInformationLanding.displayName =
  'EnquiryRequestInformationLanding'
export default EnquiryRequestInformationLanding